import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectRank = (state : GlobalState) => state.hostess.rank;

export const hostessRankSelector = createSelector(
    [selectRank],
    (data ) => data
)
